module.exports = __webpack_public_path__ + "static/media/iconDocsPending.aea9d3f0.svg";